const ACCESS_TOKEN_PREFERENCE_KEY = 'sinoaw_access_token_preference';

export function readAccessTokenPreference() {
  try {
    const value = JSON.parse(localStorage.getItem(ACCESS_TOKEN_PREFERENCE_KEY) || 'null');
    if (!value || !value.id) {
      return null;
    }
    return {
      id: Number(value.id),
      name: value.name || '',
      savedAt: Number(value.savedAt || 0),
    };
  } catch (error) {
    return null;
  }
}

export function saveAccessTokenPreference(token) {
  if (!token?.id) {
    return null;
  }
  const value = {
    id: Number(token.id),
    name: token.name || '',
    savedAt: Date.now(),
  };
  localStorage.setItem(ACCESS_TOKEN_PREFERENCE_KEY, JSON.stringify(value));
  return value;
}
